import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import { get as getAnalyticsData } from '../../state/analytics/selectors.tsx';
import { isAdmin } from '../../state/context/selectors.tsx';
import type { State } from '../../state/reducer.tsx';
import { initiate as initiateAddComponent } from '../../state/ui/add/actions.tsx';
import EmptyPlaceholderView from './view.tsx';

const mapStateToProps = (state: State) => ({
	analyticsData: getAnalyticsData(state),
	canAddComponent: isAdmin(state),
});

const mapDispatchToProps = {
	onAddComponent: initiateAddComponent,
} as const;

export default connect(mapStateToProps, mapDispatchToProps)(EmptyPlaceholderView);
